import { useQuery } from '@tanstack/react-query';

import { transactionsService, ChildTransaction } from '@aslanpay/portal-common-lib';

const useFetchChildTransactions = (transactionId: string) => {
  return useQuery<ChildTransaction[], Error>(
    ['fetchChildTransactions', transactionId],
    async () => {
      const transactions = await transactionsService.fetchChildTransactions(transactionId);

      return transactions.list;
    },
    { enabled: !!transactionId }
  );
};

export default useFetchChildTransactions;
